import GroupLayout from "./GroupLayout";

const AsterLayout = () => (
  <GroupLayout
    brandName="Aster"
    logoUrl="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/aster.png"
    groupId="10000000056"
    headline="Aster Institutions"
  />
);

export default AsterLayout;
